export function matchesSearchWithSynonyms(
  input: string,
  label: string,
  synonyms?: string[]
): boolean {
  const normalizedInput = input.trim().toLowerCase();

  if (!normalizedInput) {
    return false;
  }

  return [label]
    .concat(synonyms || [])
    .map((value) => value.toLowerCase())
    .some((value) => value.includes(normalizedInput));
}
